<template>
    <section role="main" class="gallery-single">

      <div class="gallery-single__title-block">
        <a href="/swp/gallery"><span class="gallery-single__title-arrow"></span> Back to Gallery</a>
        <h1 v-if="gallery">{{gallery.title.rendered}}</h1>
      </div>

      <div class="project__gallery" v-if="galleryImages">

        <div class="gallery__controls">
          <a @click="prev" class="gallery__prev"></a>
          <a @click="next" class="gallery__next"></a>
        </div>
        <div class="gallery__slider">
          <div class="gallery__slider-frame">
            <transition name="slide-fade">
              <ImageSlider
                      :slides="galleryImages"
                      :tip-str-show="false"
                      background-size="contain"
                      transition-type="slide-fade">
                <Spinner slot="loader"></Spinner>
                <!--<div slot="loader" class="spinner centered" id="spinner"></div>-->
              </ImageSlider>
            </transition>
          </div>
        </div>
        <div class="gallery__thumbs-comp">
          <slider-thumbs
                  v-if="galleryImages && galleryImages.length > 0"
                  :projectThumbs="galleryImages"
                  @selectImage="selectImage"
          ></slider-thumbs>
        </div>

      </div>

      <!--<div class="gallery-single__slideshow-wrapper">
        <ul class="gallery-single__slideshow">
          <li v-for="(image, key) in gallery.acf.image" :id="`#${key}`" class="gallery-single__slideshow-img"
               :style="`background: url('${image.sizes['1536x1536']}') no-repeat; background-size: contain; background-position: center;`"
          ></li>
        </ul>
      </div>-->


     <!-- <div class="gallery-single__thumbs-wrapper">
        <ul class="gallery-single__thumbs">
          <li class="gallery-single__thumb" v-for="(image, key) in gallery.acf.image">
            <a :href="`#${key}`">
              <img :src="image.sizes['gallery-thumb']"
                   alt="<?php echo esc_attr( $image['alt'] ); ?>"/>
            </a>
            <p><?php echo esc_html( $image['caption'] ); ?></p>
          </li>
        </ul>
      </div>-->

    </section>
</template>

<script>
  import eventHub from '@/plugins/EventHub.js';
import { mapState, mapActions } from 'vuex';

  import ImageSlider from '@/components/image-slider/ImageSlider'
  import SliderThumbs from '@/components/image-slider/SliderThumbs'
  import Spinner from '@/components/Spinner';

export default {
  name: 'AWGallery',
  components   : {
    ImageSlider,
    SliderThumbs,
    Spinner
  },
  data() {
    return {
      isSliderShowing: false,
      bg             : null,
      currentBg      : null,
      showPanel      : false,
      showSlider     : false,
      showBg         : false,
      showShare      : false,
      debug          : false
    }
  },
  computed: {
    ...mapState([
            'gallery',
            'mobile',
            'selectedImage',
    ]),
    galleryImages() {
      return this.formatImages(this.gallery.acf.image)
    },
  },
  mounted() {
    eventHub.$on('selectImage', (imageId) => {
      window.scrollTo(0,0);
    });
  },
  methods: {
    ...mapActions([
            'loadGallery',
    ]),
    selectImage(image) {
      // console.log('Image selected: ', image);
    },
    next() {
      eventHub.$emit('next');
      if (this.debug) console.log('clicked next');
    },
    prev() {
      eventHub.$emit('prev');
      if (this.debug) console.log('clicked prev');
    },
    formatImages(imgArr) {
      if (!imgArr) {
        return
      }
      let images = [];
      for (let i = 0; i < imgArr.length; i++) {
        // console.log(imgArr[ i ]);
        if (imgArr[i].type === 'image') {
          images.push(imgArr[i].url);
        } else if (imgArr[i].type === 'video') {
          console.log('video');
          let j = {
            type: 'video',
            url: imgArr[i].url
          };

          images.push(j);
        }
      }
      // console.log('slides: ', images);
      return images;
    },
  }
}
</script>

<style scoped lang="scss">
  @import "src/assets/scss/main";

  /* Enter and leave animations can use different */
  /* durations and timing functions.              */
  .slide-fade-enter-active {
    transition: transform, opacity 1.5s ease;
  }

  .slide-fade-leave-active {
    transition: transform, opacity 1.5s cubic-bezier(.1, .65, .98, .36);
  }

  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */
  {
    /*transform: translateY(10px);*/
    opacity: 0;
  }

  .project__gallery {
    overflow: hidden;
  }

  .single-project__wrapper {
    position: relative;
    z-index: 3;
  }

  .single-project,
  .bg {
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 0;
    /*transition: all .2s linear;*/
  }

  .blur {
    position: absolute;
    height: 104%;
    width: 104%;
    top: -2%;
    left: -2%;
    filter: blur(15px) brightness(.6);

  }

  .dim {
    position: absolute;
    height: 100%;
    width: 100%;
    filter: brightness(.2);
    z-index: 2;
    will-change: opacity;
  }

  .dark-bg {
    position: absolute;
    height: 100%;
    width: 100%;
    background-color: #000;
    z-index: 1;
  }

  .fade-enter,
  .fade-leave,
  .fade-slow-enter,
  .fade-slow-leave {
    opacity: 0;
    /*visibility: hidden;*/
  }

  .fade-enter-active,
  .fade-leave-active
  {
    transition: all .2s
  }

  .fade-enter,
  .fade-leave-to,
  .fade-slow-enter,
  .fade-slow-leave-to
    /* .fade-leave-active in <2.1.8 */
  {
    opacity: 0
  }

  .fade-slow-enter-active,
  .fade-slow-leave-active {
    transition: opacity 1s
  }

  .slide-fade-enter-active,
  .slide-up-enter-active {
    transition: all .5s ease;
  }

  .slide-fade-leave-active,
  .slide-up-leave-active {
    transition: all .5s cubic-bezier(.1, .65, .98, .36);
  }

  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */
  {
    /*transform: translateX(10px);*/
    opacity: 0;
  }

  .slide-up-enter, .slide-up-leave-to {
    /*transform: translateY(10px);*/
    opacity: 0;
  }

  .gallery__controls {
    z-index: 100;

    a {
      cursor: pointer;
    }
  }

  .gallery__thumbs-comp {
    display: block;
    width: 100%;
  }


</style>
